// ============================================================
// ADMIN LAYOUT WRAPPER
// ============================================================

import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';

const AdminLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="admin-wrapper">
      <div className="admin-layout">
        <Sidebar
          collapsed={collapsed}
          onToggle={() => setCollapsed(p => !p)}
          mobileOpen={mobileOpen}
        />
        <div className={`admin-main-content ${collapsed ? 'sidebar-collapsed' : ''}`}>
          <Header
            collapsed={collapsed}
            onMenuToggle={() => setMobileOpen(p => !p)}
          />
          <main className="admin-page-content">
            {children}
          </main>
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
